<template>
  <el-dialog title="Información de alérgenos" :visible="value" :show-close="false" width="90%" custom-class="customer-dialog" append-to-body @close="$emit('input', false)">
    <div class="allergen-grid"><div v-for="allergen in allergens" :key="allergen.key"><img :src="allergen.url" :alt="allergen.name" /><p>{{ allergen.name }}</p></div></div>
    <p v-if="!allergens.length">Consulta al personal del restaurante para conocer los alérgenos.</p>
    <div slot="footer"><el-button class="customer-dialog-close" @click="$emit('input', false)">Cerrar</el-button></div>
  </el-dialog>
</template>
<script>export default { props: { value: Boolean, allergens: { type: Array, default: () => [] } } };</script>
